import { tv } from "tailwind-variants";

export const button = tv({
    base: [
        "tw:inline-block tw:text-center tw:select-none",
        "tw:not-disabled:cursor-pointer",
        "tw:relative",
        "tw:transition-[background-color,color,box-shadow]",
        "tw:disabled:opacity-65",
        "tw:focus-visible:outline-none!",

        "tw:group-[*]/inputgroup:not-first:rounded-l-none",
        "tw:group-[*]/inputgroup:not-last:rounded-r-none",
        "tw:group-[*]/inputgroup:not-last:-mr-px!"
    ],

    variants: {
        color: {
            // Brand colors
            "primary": "tw:font-semibold",
            "secondary": "tw:font-semibold",
            "tertiary": "tw:font-semibold",

            // Semantic colors
            "information": "tw:font-semibold",
            "success": "tw:font-semibold",
            "warning": "tw:font-semibold",
            "danger": "tw:font-semibold",

            // Neutral colors
            "transparent": "tw:font-semibold",
            "gray": "tw:font-semibold",
            "light-gray": "tw:font-semibold",
            "dark": "tw:font-semibold",

            // Link
            "link": ""
        },

        outline: {
            false: "",
            true: ""
        },

        size: {
            sm: "tw:px-4 tw:py-2 tw:text-sm! tw:leading-5 tw:rounded-md",
            md: "tw:px-5 tw:py-3 tw:leading-6 tw:rounded-md",
            lg: "tw:px-6 tw:py-4 tw:text-xl! tw:leading-7 tw:rounded-lg"
        },

        fullWidth: {
            true: "tw:w-full"
        },

        loading: {
            true: [
                "tw:before:content-['']",
                "tw:before:animate-loading-bar",
                "tw:before:block tw:before:h-full tw:before:w-10",
                "tw:before:absolute tw:before:top-0 tw:before:left-0",
                "tw:before:p-0 tw:before:opacity-30"
            ]
        }
    },
    compoundVariants: [
        // COLOR -> NO OUTLINE
        // Brand colors
        {
            outline: false,
            color: "primary",
            class: "tw:text-white tw:bg-primary tw:not-disabled:hover:bg-primary-focus tw:focus:bg-primary-focus tw:focus:ring-3 tw:ring-primary/40"
        },
        {
            outline: false,
            color: "secondary",
            class: "tw:text-white tw:bg-secondary tw:not-disabled:hover:bg-secondary-focus tw:focus:bg-secondary-focus tw:focus:ring-3 tw:ring-secondary/40"
        },
        {
            outline: false,
            color: "tertiary",
            class: "tw:text-white tw:bg-tertiary tw:not-disabled:hover:bg-tertiary-focus tw:focus:bg-tertiary-focus tw:focus:ring-3 tw:ring-tertiary/40"
        },
        // Semantic colors
        {
            outline: false,
            color: "information",
            class: "tw:text-white tw:bg-information tw:not-disabled:hover:bg-information-focus tw:focus:bg-information-focus tw:focus:ring-3 tw:ring-information/40"
        },
        {
            outline: false,
            color: "success",
            class: "tw:text-white tw:bg-success tw:not-disabled:hover:bg-success-focus tw:focus:bg-success-focus tw:focus:ring-3 tw:ring-success/40"
        },
        {
            outline: false,
            color: "warning",
            class: "tw:text-white tw:bg-warning tw:not-disabled:hover:bg-warning-focus tw:focus:bg-warning-focus tw:focus:ring-3 tw:ring-warning-focus/50"
        },
        {
            outline: false,
            color: "danger",
            class: "tw:text-white tw:bg-danger tw:not-disabled:hover:bg-danger-focus tw:focus:bg-danger-focus tw:focus:ring-3 tw:ring-danger/40"
        },
        // Neutral colors
        {
            outline: false,
            color: "transparent",
            class: "tw:bg-transparent tw:not-disabled:hover:bg-grey-input tw:focus:bg-grey-input tw:focus:ring-3 tw:ring-grey-input/50"
        },
        {
            outline: false,
            color: "gray",
            class: "tw:bg-grey-light tw:not-disabled:hover:bg-grey-input tw:focus:bg-grey-input tw:focus:ring-3 tw:ring-grey-input/50 tw:text-black"
        },
        {
            outline: false,
            color: "light-gray",
            class: "tw:bg-grey tw:not-disabled:hover:bg-grey-light tw:focus:bg-grey-light tw:focus:ring-3 tw:ring-grey-light/50 tw:text-black"
        },
        {
            outline: false,
            color: "dark",
            class: "tw:text-white tw:bg-grey-dark tw:not-disabled:hover:bg-grey-dark-focus tw:focus:bg-grey-dark-focus tw:focus:ring-3 tw:ring-grey-dark-focus/50"
        },
        // Link
        {
            outline: false,
            color: "link",
            class: "tw:text-primary tw:not-disabled:hover:text-primary-focus tw:not-disabled:hover:underline tw:focus:text-primary-focus tw:focus:underline"
        },
        // COLOR -> OUTLINE
        // Brand colors
        {
            outline: true,
            color: "primary",
            class: "tw:text-primary tw:border tw:border-primary tw:bg-transparent tw:not-disabled:hover:bg-primary tw:not-disabled:hover:text-white tw:focus:ring-3 tw:ring-primary/40"
        },
        {
            outline: true,
            color: "secondary",
            class: "tw:text-secondary tw:border tw:border-secondary tw:bg-transparent tw:not-disabled:hover:bg-secondary tw:not-disabled:hover:text-white tw:focus:ring-3 tw:ring-secondary/40"
        },
        {
            outline: true,
            color: "tertiary",
            class: "tw:text-tertiary tw:border tw:border-tertiary tw:bg-transparent tw:not-disabled:hover:bg-tertiary tw:not-disabled:hover:text-white tw:focus:ring-3 tw:ring-tertiary/40"
        },
        // Semantic colors
        {
            outline: true,
            color: "information",
            class: "tw:text-information tw:border tw:border-information tw:bg-transparent tw:not-disabled:hover:bg-information tw:not-disabled:hover:text-white tw:focus:ring-3 tw:ring-information/40"
        },
        {
            outline: true,
            color: "success",
            class: "tw:text-success tw:border tw:border-success tw:bg-transparent tw:not-disabled:hover:bg-success tw:not-disabled:hover:text-white tw:focus:ring-3 tw:ring-success/40"
        },
        {
            outline: true,
            color: "warning",
            class: "tw:text-warning tw:border tw:border-warning tw:bg-transparent tw:not-disabled:hover:bg-warning tw:not-disabled:hover:text-white tw:focus:ring-3 tw:ring-warning/40"
        },
        {
            outline: true,
            color: "danger",
            class: "tw:text-danger tw:border tw:border-danger tw:bg-transparent tw:not-disabled:hover:bg-danger tw:not-disabled:hover:text-white tw:focus:ring-3 tw:ring-danger/40"
        },
        // Neutral colors
        {
            outline: true,
            color: "transparent",
            class: "tw:bg-transparent tw:not-disabled:hover:bg-grey-input tw:focus:bg-grey-input tw:focus:ring-3 tw:ring-grey-input/50"
        },
        {
            outline: true,
            color: "gray",
            class: "tw:text-grey-light tw:border tw:border-grey-light tw:bg-transparent tw:not-disabled:hover:bg-grey-light tw:not-disabled:hover:text-black tw:focus:ring-3 tw:ring-grey-light/40"
        },
        {
            outline: true,
            color: "light-gray",
            class: "tw:text-grey tw:border tw:border-grey tw:bg-transparent tw:not-disabled:hover:bg-grey tw:not-disabled:hover:text-black tw:focus:ring-3 tw:ring-grey/40"
        },
        {
            outline: true,
            color: "dark",
            class: "tw:text-grey-dark tw:border tw:border-grey-dark tw:bg-transparent tw:not-disabled:hover:bg-grey-dark tw:not-disabled:hover:text-white tw:focus:ring-3 tw:ring-grey-dark/40"
        },
        // Link
        {
            outline: true,
            color: "link",
            class: "tw:text-primary tw:not-disabled:hover:text-primary-focus tw:not-disabled:hover:underline tw:focus:text-primary-focus tw:focus:underline"
        },

        // COLOR -> LOADING
        // Brand colors
        {
            loading: true,
            color: "primary",
            class: "tw:before:bg-primary"
        },
        {
            loading: true,
            color: "secondary",
            class: "tw:before:bg-secondary"
        },
        {
            loading: true,
            color: "tertiary",
            class: "tw:before:bg-tertiary"
        },
        // Semantic colors
        {
            loading: true,
            color: "information",
            class: "tw:before:bg-information"
        },
        {
            loading: true,
            color: "success",
            class: "tw:before:bg-success"
        },
        {
            loading: true,
            color: "warning",
            class: "tw:before:bg-warning"
        },
        {
            loading: true,
            color: "danger",
            class: "tw:before:bg-danger"
        },
        // Neutral colors
        {
            loading: true,
            color: "transparent",
            class: "tw:before:bg-transparent"
        },
        {
            loading: true,
            color: "gray",
            class: "tw:before:bg-grey-light"
        },
        {
            loading: true,
            color: "light-gray",
            class: "tw:before:bg-grey"
        },
        {
            loading: true,
            color: "dark",
            class: "tw:before:bg-grey-dark"
        },
        // Link
        {
            loading: true,
            color: "link",
            class: "tw:before:bg-primary"
        }
    ],
    defaultVariants: {
        size: "md",
        outline: false,
        color: "primary",
        fullWidth: false,
        loading: false
    }
});
